import store from '@/store/store';

export default [

  {
    route: {name: 'app-dashboard'},
    name: 'menu.dashboard',
    slug: 'app-dashboard',
    condition () {
      return store.state.router.privateRoot && store.state.router.privateRoot.$hasLink('dashboard');
    }
  },
  {
    route: {name: 'app-send-referral'},
    name: 'menu.send_referral',
    slug: 'app-send-referral',
    condition () {
      return store.state.router.privateRoot && store.state.router.privateRoot.$hasLink('referral-send');
    }
  },
  {
    route: {name: 'app-view-leaderboard'},
    name: 'menu.view_leaderboard',
    slug: 'app-view-leaderboard',
    condition () {
      return store.state.router.privateRoot && store.state.router.privateRoot.$hasLink('leaderboard');
    }
  },
  {
    route: {name: 'app-view-referrals'},
    name: 'menu.view_referrals',
    slug: 'app-view-referrals',
    condition () {
      return store.state.router.privateRoot && store.state.router.privateRoot.$hasLink('referrals');
    }
  },
  {
    route: {name: 'app-view-members'},
    name: 'menu.view_members',
    slug: 'app-view-members',
    condition () {
      return store.state.router.privateRoot && store.state.router.privateRoot.$hasLink('members');
    }
  },
  {
    route: {name: 'app-member-reports'},
    name: 'menu.member_reports',
    slug: 'app-member-reports',
    condition () {
      return store.state.router.privateRoot && store.state.router.privateRoot.$hasLink('member-reports');
    }
  },
  {
    route: {name: 'app-analysis'},
    name: 'menu.analysis',
    slug: 'app-analysis',
    condition () {
      return store.state.router.privateRoot && store.state.router.privateRoot.$hasLink('analysis');
    }
  }
];
